document.addEventListener('DOMContentLoaded', function() {
  // Mobile menu toggle functionality
  const menuHeadings = document.querySelectorAll('.footer-item-block[data-type="link-list"] h2.menu-heading');
  const newsletterHeadings = document.querySelectorAll('.footer-newsletters .footer-newsletters h2.footer-social-heading');
  
  // Function to toggle content
  function toggleContent(heading, contentSelector) {
    heading.addEventListener('click', function() {
      if (window.innerWidth <= 1180) { // Only on mobile
        this.classList.toggle('activ');
        const content = this.closest('.footer-item-block').querySelector(contentSelector);
        if (content) {
          content.classList.toggle('activ');
        }
      }
    });
  }
  
  // Add toggle to menu headings
  menuHeadings.forEach(heading => {
    toggleContent(heading, 'ul.footer-block__details-content');
  });
  
  // Add toggle to newsletter and social headings
  newsletterHeadings.forEach(heading => {
    const block = heading.closest('.footer-newsletters');
    if (block) {
      toggleContent(heading, '.footer-newsletters > *:not(h2)');
    }
  });
});

// Start the timer as soon as the script is parsed
console.time('Footer Load Time');

document.addEventListener('DOMContentLoaded', function() {
  const startTime = performance.now();
  
  // ... (Your existing toggle logic here) ...

  const endTime = performance.now();
  const totalTime = (endTime - startTime).toFixed(2);
  
  console.timeEnd('Footer Load Time');
  console.log(`%c Footer Logic Execution: ${totalTime}ms`, 'color: #2ecc71; font-weight: bold;');
});